<template>
  <div  :class="['main-content','sn-content']">
    <el-card v-if="user.status == '2'" class="box-card">
      <div>
        <div class="vertical">
          <i  class="el-icon-warning-outline" style="color: orange"></i>
          <router-link  :to="{path:'/uac/authc'}"  style="color: orange">去认证</router-link>
        </div>
        <p class="tag" style="">企业用户请先进行账号认证，认证通过后，才可以申请sdk授权码</p>
      </div>
    </el-card>

    <div v-else>
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <p style="text-align: left;margin-top: 20px">基础信息</p>
        <div class="box-card is-always-shadow">
          <el-form-item label="" class="pxy-form-item pxy-form-item-line">
            <div class="pxy-tag-label">
              <span style="width: 200px">sdk授权类型：</span>
              <el-checkbox-group v-model="form.sdkType" style="display: inline-block">
                <el-checkbox label="1">APP</el-checkbox>
                <el-checkbox label="2">VR</el-checkbox>
                <el-checkbox label="3">Web</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item v-if="user.partnerFlag === 1 && partnersdkSnCnt < 10" label="" class="pxy-form-item pxy-form-item-line">
            <div class="pxy-tag-label">
              <span style="width: 200px">行业伙伴免费SDK授权：</span>
              <el-checkbox  v-model="form.partnerFreeFlag"></el-checkbox>
            </div>
            <el-tag type="warning">*开通行业伙伴免费SDK授权，可以免费使用SDK授权，不可商业使用，最多可申请10个，已申请{{partnersdkSnCnt}}个</el-tag>
          </el-form-item>
          <el-form-item label="" prop="note">
            <div class="pxy-tag-label">
              <span style="width: 200px">备注：</span>
            </div>
            <el-input placeholder="30个字符以内，例如项目名" v-model="form.note" style="width:500px"></el-input>
          </el-form-item>
        </div>

      </el-form>
      <div class="price-detail">
        <div class="item ">
          <div  v-for="(item, index) in (form.partnerFreeFlag ? partnerItemList : commItemList)" v-if="item.checkStatus">
            <span class="title">{{item.itemName}}：</span>
            <span class="unit">￥</span>
            <span class="price">{{item.price}}</span>
            <span class="unit"> {{item.priceUnit}}</span>
          </div>
        </div>
        <div  class="item" style="">
          <el-button type="primary" class="pxy-primary" plain @click="addSdk()">确认</el-button>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
  import {Message} from "element-ui";

  export default {
    components: {},
    data() {
      return {
        loading: false,
        sdkSnProdItemList: [], //所有的计价规则
        commItemList: [], //通用计价规则
        partnerItemList: [], //行业伙伴计价规则
        form: {
          sdkType: ["1","2","3"],
          note: '',
          partnerFreeFlag: false
        },
        rules: {
          note: [{max: 30, message: "长度在30个字符以内", trigger: 'blur'}],},
        // 增值服务的开启数量
        extraCnt: 0,
        // 行业伙伴免费SDK授权
        partnersdkSnCnt: 0,
      }
    },
    created() {
    },
    methods: {
      getProcProdItem: function () {
        this.getRequest('/pocPriceItem/list', {"type": 2}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.sdkSnProdItemList = resp.data.result;
              console.log(this.sdkSnProdItemList)
              this.commItemList = this.sdkSnProdItemList.filter(item => item.prodId == '955751524988878848');
              this.partnerItemList = this.sdkSnProdItemList.filter(item => item.prodId == '876867839321964545');
              this.commItemList.forEach((item, index) => {
                this.$set(item, 'checkStatus', true);
              })
              this.partnerItemList.forEach((item, index) => {
                this.$set(item, 'checkStatus', true);
              })
              console.log(this.commItemList)
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      addSdk: function () {
        var _this = this;
        var params = {
          partnerFreeFlag: this.form.partnerFreeFlag? 'Y': 'N'// 行业伙伴免费授权Y:是; N: 否
        };
        params.sdkType = _this.form.sdkType.join(",");
        params.note =  _this.form.note;
        params.serviceItemList = this.user.partnerFlag && this.form.partnerFreeFlag ?
          this.partnerItemList.filter(item => item.checkStatus)
          : this.commItemList.filter(item => item.checkStatus);
        console.log(params);
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.postRequestJson('/pocSdkid/add', JSON.stringify(params)).then(resp => {
              _this.loading = false;
              if (resp && resp.status == 200) {
                var data = resp.data;
                if (data.code == 1000) {
                  Message.success(data.message);
                  this.$router.replace({path: '/sdkLicence/index'});

                } else {
                  Message.error(data.message);

                }
              }
            });
          }
        })
      },
      changeContentHeight:function(flag){
        if(flag){
          this.extraCnt += 1;
        }else {
          this.extraCnt -= 1;
        }
        this.heightC = 'heightN'+this.extraCnt;
      },

      getPartnerSnCnt:function () {
        var params = {
          partnerFreeFlag: "Y",
          status: "0",
          page:1,
          pageSize:20
        };
        this.getRequest('/pocSdkid/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.partnersdkSnCnt = resp.data.result.total;
            }}});
      }
    }
    ,
    mounted: function () {
      this.getProcProdItem();

      //修改云授权码

      //如果用户符合开通行业伙伴授权的权限，查询行业伙伴授权开通了多少个
      if(this.user.partnerFlag == '1'){
        this.getPartnerSnCnt();
      }
    }
    ,
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    beforeDestroy() {

    }
  }
</script>

<style scoped>
.sn-content .pxy-form-item .el-checkbox{
  float: none;
}
.box-card {
  text-align: left;
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
    border-radius: 4px;
    padding: 20px;

}
@media screen and (max-width: 768px) {
  /* 1px solid #EBEEF5 */
  .pxy-form-item .el-form-item__content .el-tag {
    height: auto!important;
    white-space: normal!important;
  }
  .pxy-form-item {
    margin-bottom: 10px!important;
    padding-bottom: 15px!important;
    box-sizing: border-box!important;
  }
  .pxy-form-item-line {
    border-bottom: 1px solid #EBEEF5!important;
  }
}

@media screen and (min-width: 769px) {
  .pxy-form-item .el-form-item__content {
    margin-left: 0!important;
  }
  .pxy-form-item .el-form-item__content .el-tag {
    margin-left: 10px!important;
  }
  .pxy-tag-label {
    display: inline-block;
  }
}
</style>
